(function () {
  'use strict';

  const angular = window.angular;

  angular.module('app').directive('inlineEdit', [
    '$compile',
    '$timeout',
    function ($compile, $timeout) {
      return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
          ngModel: '=',
          ngChange: '&?',
          ngBlur: '&?',
          ngKeypress: '&?',
        },
        link: function (scope, element, attrs, ngModelCtrl) {
          let inputEl;

          element.css('cursor', 'pointer');

          element.on('click', () => {
            if (inputEl) {
              return;
            }

            const currentValue = scope.ngModel;

            inputEl = angular.element(
              `<input type="text" 
                ng-model="ngModel"
                ${attrs.ngChange ? 'ng-change="ngChange()"' : ''}
                ng-blur="handleBlur()"
                ng-keypress="handleKeypress($event)"
                class="form-control no-margin" 
                style="width: 100%; border: none; padding: 0 5px; height: auto; border-radius: 0" />`
            );
            inputEl.val(currentValue);

            $compile(inputEl)(scope);

            element.empty();
            element.append(inputEl);

            $timeout(() => {
              inputEl[0].focus();
              inputEl[0].select();
            });
          });

          scope.$watch('ngModel', function (newVal) {
            if (!inputEl) {
              element.text(newVal);
            }
          });

          scope.handleBlur = function () {
            element.text(scope.ngModel);
            inputEl = null;

            if (scope.ngBlur) {
              scope.ngBlur();
            }
          };

          scope.handleKeypress = function (e) {
            if (e.key === 'Enter') {
              e.target.blur(); // dispara ng-blur
            } else if (e.key === 'Escape') {
              // Opcional: restaurar valor anterior si se desea
              e.target.blur();
            }
          };
        },
      };
    },
  ]);
})();
